import { render, staticRenderFns } from "./DuravitLogo.vue?vue&type=template&id=2e89a682&scoped=true&"
var script = {}
import style0 from "./DuravitLogo.vue?vue&type=style&index=0&id=2e89a682&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e89a682",
  null
  
)

export default component.exports